import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 2,
  class: "bloque-imagen"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "imagen-titulo"
}
const _hoisted_5 = {
  key: 2,
  class: "sin-datos"
}
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  key: 0,
  class: "tabla-custom-titulo"
}
const _hoisted_8 = {
  key: 1,
  class: "contenedor-tabla"
}
const _hoisted_9 = { class: "lista-tabla" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = {
  key: 2,
  class: "sin-datos"
}
const _hoisted_13 = {
  key: 4,
  class: "sin-datos"
}
const _hoisted_14 = {
  key: 5,
  class: "kpis-grid"
}
const _hoisted_15 = {
  key: 0,
  class: "kpi-card"
}
const _hoisted_16 = { class: "kpi-valor" }
const _hoisted_17 = {
  key: 1,
  class: "kpi-card"
}
const _hoisted_18 = { class: "kpi-valor" }
const _hoisted_19 = {
  key: 2,
  class: "kpi-card"
}
const _hoisted_20 = {
  key: 3,
  class: "kpi-card"
}
const _hoisted_21 = { class: "kpi-valor" }
const _hoisted_22 = {
  key: 6,
  class: "contenedor-tabla"
}
const _hoisted_23 = { class: "lista-tabla" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = {
  key: 7,
  class: "col-num"
}
const _hoisted_32 = {
  key: 8,
  class: "col-num"
}
const _hoisted_33 = {
  key: 9,
  class: "col-num"
}
const _hoisted_34 = { key: 10 }
const _hoisted_35 = {
  key: 0,
  class: "fila-aspecto"
}
const _hoisted_36 = ["rowspan"]
const _hoisted_37 = ["rowspan"]
const _hoisted_38 = ["rowspan"]
const _hoisted_39 = ["rowspan"]
const _hoisted_40 = ["rowspan"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "nombre"
}
const _hoisted_43 = { key: 5 }
const _hoisted_44 = {
  key: 6,
  class: "nombre"
}
const _hoisted_45 = {
  key: 7,
  class: "col-num"
}
const _hoisted_46 = ["rowspan"]
const _hoisted_47 = {
  key: 9,
  class: "col-num"
}
const _hoisted_48 = ["rowspan"]
const _hoisted_49 = {
  key: 11,
  class: "col-num"
}
const _hoisted_50 = ["rowspan"]
const _hoisted_51 = {
  key: 1,
  class: "fila-subtotal"
}
const _hoisted_52 = ["colspan"]
const _hoisted_53 = {
  key: 0,
  class: "col-num"
}
const _hoisted_54 = {
  key: 1,
  class: "col-num"
}
const _hoisted_55 = {
  key: 2,
  class: "col-num"
}
const _hoisted_56 = {
  key: 0,
  class: "fila-global"
}
const _hoisted_57 = ["colspan"]
const _hoisted_58 = {
  key: 0,
  class: "col-num"
}
const _hoisted_59 = {
  key: 1,
  class: "col-num"
}
const _hoisted_60 = {
  key: 2,
  class: "col-num"
}
const _hoisted_61 = { key: 7 }
const _hoisted_62 = { class: "resumen-cards" }
const _hoisted_63 = { class: "resumen-titulo" }
const _hoisted_64 = { class: "resumen-fila" }
const _hoisted_65 = { class: "resumen-fila" }
const _hoisted_66 = { class: "resumen-fila" }
const _hoisted_67 = { class: "resumen-fila" }
const _hoisted_68 = { class: "contenedor-tabla" }
const _hoisted_69 = { class: "lista-tabla" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = {
  key: 2,
  class: "col-num"
}
const _hoisted_73 = {
  key: 3,
  class: "col-sem"
}
const _hoisted_74 = {
  key: 4,
  class: "col-sem"
}
const _hoisted_75 = {
  key: 5,
  class: "col-sem"
}
const _hoisted_76 = {
  key: 0,
  class: "fila-caract-head"
}
const _hoisted_77 = ["colspan"]
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  key: 1,
  class: "nombre"
}
const _hoisted_80 = {
  key: 2,
  class: "col-num"
}
const _hoisted_81 = {
  key: 3,
  class: "col-sem"
}
const _hoisted_82 = {
  key: 0,
  class: "marca fuerte"
}
const _hoisted_83 = {
  key: 4,
  class: "col-sem"
}
const _hoisted_84 = {
  key: 0,
  class: "marca debil"
}
const _hoisted_85 = {
  key: 5,
  class: "col-sem"
}
const _hoisted_86 = {
  key: 0,
  class: "marca muy_debil"
}
const _hoisted_87 = {
  key: 8,
  class: "contenedor-tabla"
}
const _hoisted_88 = { class: "lista-tabla estructura" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 2 }
const _hoisted_92 = {
  key: 3,
  class: "col-num"
}
const _hoisted_93 = {
  key: 4,
  class: "col-num"
}
const _hoisted_94 = {
  key: 5,
  class: "col-num"
}
const _hoisted_95 = { key: 6 }
const _hoisted_96 = { key: 7 }
const _hoisted_97 = {
  key: 0,
  class: "cod"
}
const _hoisted_98 = { key: 1 }
const _hoisted_99 = {
  key: 2,
  class: "nombre"
}
const _hoisted_100 = {
  key: 3,
  class: "col-num"
}
const _hoisted_101 = {
  key: 4,
  class: "col-num"
}
const _hoisted_102 = {
  key: 5,
  class: "col-num"
}
const _hoisted_103 = { key: 6 }
const _hoisted_104 = { key: 7 }
const _hoisted_105 = {
  key: 9,
  class: "graficos"
}
const _hoisted_106 = { class: "grafico-titulo" }
const _hoisted_107 = ["viewBox"]
const _hoisted_108 = ["y2"]
const _hoisted_109 = ["y1", "x2", "y2"]
const _hoisted_110 = ["y1", "y2"]
const _hoisted_111 = ["y"]
const _hoisted_112 = ["x", "y", "width", "height", "fill"]
const _hoisted_113 = ["x", "y"]
const _hoisted_114 = ["x", "y"]
const _hoisted_115 = { key: 10 }
const _hoisted_116 = { class: "grafico-titulo" }
const _hoisted_117 = ["viewBox"]
const _hoisted_118 = ["y2"]
const _hoisted_119 = ["y1", "x2", "y2"]
const _hoisted_120 = ["y1", "y2"]
const _hoisted_121 = ["y"]
const _hoisted_122 = ["x", "y", "width", "height", "fill"]
const _hoisted_123 = ["x", "y"]
const _hoisted_124 = ["x", "y"]
const _hoisted_125 = {
  key: 1,
  class: "sin-datos"
}

import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'
import type { NodoResultado, Clasificacion } from '@/interfaces/ResultadosAutoevaluacion'
import ComparativoSeccion from '@/components/ComparativoSeccion.vue'

const DRAG_THRESHOLD = 4

interface ExtraColumna { id: string; titulo: string; filas: Record<string, string> }

/** Columna del sistema visible (o todas si no hay config) */
interface FilaGeneral {
  key: string; tipo: 'aspecto' | 'subtotal'; factor: NodoResultado
  factorRowspan?: number; mostrarFactor?: boolean
  caract?: NodoResultado; caractRowspan?: number; mostrarCaract?: boolean
  aspecto?: NodoResultado | null
}

interface FilaEstructura {
  key: string; stableKey: string; codigo: string; tipo: string; tipoNivel: number
  nombre: string; peso: number | null; valoracion: number | null; pct: number | null
  grado: string | null; clasificacion: Clasificacion
}

interface DatoGrafico {
  id: number; ordinal: string | null; nombre: string
  barras: { ordinal: string | null; valor: number | null; clasificacion: Clasificacion }[]
  paso: number; anchoBarra: number; width: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BloqueDatos',
  props: {
    tipo: {},
    params: {},
    modoPreview: { type: Boolean }
  },
  emits: ["update:vistaInicial"],
  setup(__props: any, { emit: __emit }) {

/**
 * Bloque de datos embebido en el informe.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const rootEl = ref<HTMLElement | null>(null)

const drag = { pending: false, active: false, el: null as HTMLElement | null, startX: 0, startY: 0, scrollLeft: 0, scrollTop: 0 }
function findScrollable(target: EventTarget | null): HTMLElement | null {
  let node = target as Element | null
  while (node && node !== rootEl.value) {
    if (node instanceof HTMLElement && node.classList.contains('contenedor-tabla')) return node
    node = node.parentElement
  }
  return null
}

function onDragStart(e: MouseEvent) {
  if (e.button !== 0) return
  const el = findScrollable(e.target)
  if (!el) return
  drag.pending = true
  drag.active = false
  drag.el = el
  drag.startX = e.pageX
  drag.startY = e.pageY
  drag.scrollLeft = el.scrollLeft
  drag.scrollTop = el.scrollTop
}

function onDragMove(e: MouseEvent) {
  if (!drag.el) return
  const dx = e.pageX - drag.startX
  const dy = e.pageY - drag.startY
  if (!drag.active) {
    if (!drag.pending || (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD)) return
    drag.active = true
    drag.pending = false
    drag.el.style.cursor = 'grabbing'
    drag.el.style.userSelect = 'none'
  }
  e.preventDefault()
  drag.el.scrollLeft = drag.scrollLeft - dx
  drag.el.scrollTop  = drag.scrollTop  - dy
}

function onDragEnd() {
  if (!drag.el) return
  drag.el.style.cursor = ''
  drag.el.style.userSelect = ''
  drag.active = false
  drag.pending = false
  drag.el = null
}

onMounted(() => {
  rootEl.value?.addEventListener('mousedown', onDragStart)
  window.addEventListener('mousemove', onDragMove)
  window.addEventListener('mouseup', onDragEnd)
})

onUnmounted(() => {
  rootEl.value?.removeEventListener('mousedown', onDragStart)
  window.removeEventListener('mousemove', onDragMove)
  window.removeEventListener('mouseup', onDragEnd)
})

const props = __props

const emit = __emit

const store = useGestionResultadosAutoevaluacion()
const datos = computed(() => store.resultados)
const escala = computed(() => datos.value?.escala_max ?? 5)
const factores = computed(() => datos.value?.factores ?? [])

// ── Params helpers ────────────────────────────────────────────────────────────

function col(clave: string): boolean {
  const cols = props.params?.columnas as string[] | undefined
  return !cols || cols.includes(clave)
}

/** KPI card visible */
function kpiVisible(clave: string): boolean {
  const t = props.params?.tarjetas as string[] | undefined
  return !t || t.includes(clave)
}

const extraCols = computed<ExtraColumna[]>(() => props.params?.columnasExtra ?? [])

/** Altura SVG para gráficos */
const svgH = computed<number>(() =>
  ({ sm: 150, md: 200, lg: 280 }[props.params?.altura as string ?? 'md'] ?? 200)
)

/** Ancho máximo de cada tarjeta de gráfico en px */
const anchoGrafico = computed<number>(() =>
  ({ sm: 300, md: 420, lg: 560 }[props.params?.ancho as string ?? 'md'] ?? 420)
)

// ── Helpers de formato ────────────────────────────────────────────────────────

const evaluados = computed(() => {
  const r = datos.value?.resumen.aspectos
  if (!r) return '—'
  return r.fuerte + r.debil + r.muy_debil
})

function fmtOrdinal(ordinal: string | null | undefined): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}
function fmtVal(v: number | null | undefined): string {
  return v == null ? '—' : v.toFixed(2)
}
function fmtPct(v: number | null | undefined): string {
  return v == null ? '—' : `${v.toFixed(1)}%`
}
function fmtPeso(v: number | null | undefined): string {
  if (v == null) return '—'
  return `${(+v).toFixed(v % 1 === 0 ? 0 : 2)}%`
}
function clasLabel(c: Clasificacion): string {
  return { fuerte: 'Fuerte', debil: 'Débil', muy_debil: 'Muy débil', no_aplica: 'No aplica' }[c]
}
function clasColor(c: Clasificacion): string {
  return { fuerte: '#28a745', debil: '#ffc107', muy_debil: '#dc3545', no_aplica: '#c9c9c9' }[c]
}
function nivelLabel(k: string): string {
  return ({ factores: 'Factores', caracteristicas: 'Características', aspectos: 'Aspectos' } as Record<string, string>)[k] ?? k
}
function pctResumen(n: number, total: number): string {
  return total > 0 ? `${((n / total) * 100).toFixed(1)}%` : '0%'
}
function recolectarHojas(nodo: NodoResultado): NodoResultado[] {
  if (nodo.es_hoja || !nodo.hijos.length) return [nodo]
  return nodo.hijos.flatMap(recolectarHojas)
}

// ── TABLA_GENERAL ─────────────────────────────────────────────────────────────

const filasGenerales = computed<FilaGeneral[]>(() => {
  const filas: FilaGeneral[] = []
  let n = 0
  for (const factor of factores.value) {
    const caracts = factor.hijos.length ? factor.hijos : [factor]
    const grupos = caracts.map(c => {
      const hojas = recolectarHojas(c)
      return { nodo: c, hojas: hojas.length ? hojas : [null] as (NodoResultado | null)[] }
    })
    const totalFactor = grupos.reduce((s, g) => s + g.hojas.length, 0) || 1
    let primeraFactor = true
    for (const g of grupos) {
      let primeraCaract = true
      for (const hoja of g.hojas) {
        filas.push({
          key: `a${n++}`, tipo: 'aspecto', factor,
          factorRowspan: totalFactor, mostrarFactor: primeraFactor,
          caract: g.nodo === factor ? undefined : g.nodo,
          caractRowspan: g.hojas.length, mostrarCaract: primeraCaract, aspecto: hoja
        })
        primeraFactor = false; primeraCaract = false
      }
    }
    filas.push({ key: `s${factor.id_componente}`, tipo: 'subtotal', factor })
  }
  return filas
})

// Sliced rendering for paginated preview
function reindexarFilas(filas: FilaGeneral[]): FilaGeneral[] {
  const result: FilaGeneral[] = []
  let fi = 0
  while (fi < filas.length) {
    const fId = filas[fi].factor.id_componente
    let fj = fi
    while (fj < filas.length && filas[fj].factor.id_componente === fId) fj++
    const fRows = filas.slice(fi, fj)
    let ci = 0
    while (ci < fRows.length) {
      const cId = fRows[ci].caract?.id_componente ?? -1
      let cj = ci
      while (cj < fRows.length && (fRows[cj].caract?.id_componente ?? -1) === cId) cj++
      const cRows = fRows.slice(ci, cj)
      for (let ri = 0; ri < cRows.length; ri++) {
        result.push({
          ...cRows[ri],
          factorRowspan: fRows.length,
          mostrarFactor: ci === 0 && ri === 0,
          caractRowspan: cRows.length,
          mostrarCaract: ri === 0
        })
      }
      ci = cj
    }
    fi = fj
  }
  return result
}

const filasVista = computed<FilaGeneral[]>(() => {
  const slice = props.params?.rowSlice as { start: number; end: number } | undefined
  if (!slice) return filasGenerales.value
  const aspectos = filasGenerales.value.filter(f => f.tipo === 'aspecto')
  return reindexarFilas(aspectos.slice(slice.start, slice.end))
})

// Colspan para filas de subtotal/global en TABLA_GENERAL
const colSpanSubtotal = computed(() => {
  let n = 0
  if (col('n_factor'))      n++
  if (col('nombre_factor')) n++
  if (col('peso_factor'))   n++
  if (col('n_caract'))      n++
  if (col('nombre_caract')) n++
  if (col('n_aspecto'))     n++
  if (col('aspecto'))       n++
  return n || 1
})

// ── TABLA_SEMAFORO ────────────────────────────────────────────────────────────

const gruposSemaforo = computed(() => {
  const grupos: { id: number; ordinal: string | null; nombre: string; hojas: NodoResultado[] }[] = []
  for (const factor of factores.value) {
    const caracts = factor.hijos.length ? factor.hijos : [factor]
    for (const c of caracts) {
      const hojas = recolectarHojas(c)
      if (hojas.length) grupos.push({ id: c.id_componente, ordinal: c.ordinal, nombre: c.nombre, hojas })
    }
  }
  return grupos
})

const colSpanSemaforo = computed(() => {
  let n = 0
  if (col('caract'))     n++
  if (col('aspecto'))    n++
  if (col('valoracion')) n++
  if (col('fuerte'))     n++
  if (col('debil'))      n++
  if (col('muy_debil'))  n++
  return (n || 1) + extraCols.value.length
})

// ── TABLA_ESTRUCTURA ──────────────────────────────────────────────────────────

const filasEstructura = computed<FilaEstructura[]>(() => {
  const filas: FilaEstructura[] = []
  let n = 0
  const tipoPorNivel = (nivel: number) => nivel === 1 ? 'Factor' : nivel === 2 ? 'Característica' : 'Subnivel'
  const walk = (nodo: NodoResultado) => {
    if (nodo.es_hoja && nodo.aspectos.length <= 1) {
      filas.push({ key: `e${n++}`, stableKey: `c_${nodo.id_componente}`, codigo: nodo.ordinal ?? '', tipo: 'Aspecto', tipoNivel: 3, nombre: nodo.nombre, peso: nodo.peso, valoracion: nodo.valoracion, pct: nodo.pct, grado: nodo.grado, clasificacion: nodo.clasificacion })
      return
    }
    filas.push({ key: `e${n++}`, stableKey: `c_${nodo.id_componente}`, codigo: nodo.ordinal ?? '', tipo: tipoPorNivel(nodo.nivel), tipoNivel: Math.min(nodo.nivel, 3), nombre: nodo.nombre, peso: nodo.peso, valoracion: nodo.valoracion, pct: nodo.pct, grado: nodo.grado, clasificacion: nodo.clasificacion })
    for (const a of nodo.aspectos) {
      filas.push({ key: `e${n++}`, stableKey: `a_${a.id_indicador}`, codigo: a.ordinal ?? '', tipo: 'Aspecto', tipoNivel: 3, nombre: a.nombre, peso: null, valoracion: a.valoracion, pct: a.pct, grado: a.grado, clasificacion: a.clasificacion })
    }
    for (const h of nodo.hijos) walk(h)
  }
  for (const f of factores.value) walk(f)
  return filas
})

// ── GRÁFICOS ──────────────────────────────────────────────────────────────────

function buildGrafico(f: NodoResultado): DatoGrafico {
  const caracts = f.hijos.length ? f.hijos : [f]
  const barras = caracts.map(c => ({ ordinal: c.ordinal, valor: c.valoracion, clasificacion: c.clasificacion }))
  const paso = 62
  const width = Math.max(240, 60 + barras.length * paso)
  return { id: f.id_componente, ordinal: f.ordinal, nombre: f.nombre, barras, paso, anchoBarra: 38, width }
}

const ejeTicks = computed(() => {
  const max = Math.ceil(escala.value)
  const paso = max <= 5 ? 1 : 2
  const ticks: number[] = []
  for (let t = 0; t <= max; t += paso) ticks.push(t)
  return ticks
})

function yPos(v: number): number {
  const max = escala.value || 5
  const h = svgH.value
  return (h - 40) - (Math.max(0, Math.min(max, v)) / max) * (h - 50)
}

const graficosVisibles = computed<DatoGrafico[]>(() => {
  const ids = props.params?.factoresIds as number[] | undefined
  const lista = factores.value.filter(f => !ids || ids.includes(f.id_componente))
  return lista.map(buildGrafico).filter(g => g.barras.length)
})

const graficoFactor = computed<DatoGrafico | null>(() => {
  const idComp = props.params?.id_componente
  if (!idComp) return null
  const f = factores.value.find(x => x.id_componente === idComp)
  return f ? buildGrafico(f) : null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bloque-datos",
    ref_key: "rootEl",
    ref: rootEl
  }, [
    (_ctx.tipo === 'TEXTO')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bloque-texto ql-editor",
          innerHTML: _ctx.params?.html || '<p><em>Caja de texto vacía — haga clic en Editar para redactar.</em></p>'
        }, null, 8, _hoisted_1))
      : (_ctx.tipo === 'COMPARATIVO')
        ? (_openBlock(), _createBlock(ComparativoSeccion, {
            key: 1,
            idEjecucion: _ctx.params?.id_ejecucion,
            vistaInicial: _ctx.params?.vista,
            filtroComponentes: _ctx.params?.filtroComponentes,
            soloLectura: _ctx.modoPreview,
            ocultarNivel: true,
            "onUpdate:vistaInicial": _cache[0] || (_cache[0] = ($event: any) => (emit('update:vistaInicial', $event)))
          }, null, 8, ["idEjecucion", "vistaInicial", "filtroComponentes", "soloLectura"]))
        : (_ctx.tipo === 'IMAGEN')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.params?.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.params.url,
                    alt: _ctx.params?.alt ?? '',
                    class: "imagen-bloque",
                    style: _normalizeStyle({ width: _ctx.params?.ancho ?? '100%' })
                  }, null, 12, _hoisted_3))
                : _createCommentVNode("", true),
              (_ctx.params?.titulo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.params.titulo), 1))
                : _createCommentVNode("", true),
              (!_ctx.params?.url)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Sin imagen — haga clic en Opciones para configurar."))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.tipo === 'TABLA_CUSTOM')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.params?.titulo)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.params.titulo), 1))
                  : _createCommentVNode("", true),
                (_ctx.params?.headers?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("table", _hoisted_9, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params.headers, (h, i) => {
                              return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(h || '—'), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.params.rows ?? []), (row, ri) => {
                            return (_openBlock(), _createElementBlock("tr", { key: ri }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, ci) => {
                                return (_openBlock(), _createElementBlock("td", { key: ci }, _toDisplayString(cell), 1))
                              }), 128))
                            ]))
                          }), 128)),
                          (!(_ctx.params.rows ?? []).length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                _createElementVNode("td", {
                                  colspan: _ctx.params.headers.length,
                                  class: "sin-datos"
                                }, "Sin filas.", 8, _hoisted_11)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_12, "Sin tabla — haga clic en Opciones para configurar."))
              ]))
            : (!datos.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Datos de resultados no disponibles."))
              : (_ctx.tipo === 'KPIS_RESUMEN')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (kpiVisible('total'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "kpi-label" }, "Total indicadores", -1)),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(datos.value.resumen.aspectos.total), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (kpiVisible('evaluados'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "kpi-label" }, "Evaluados", -1)),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(evaluados.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (kpiVisible('promedio'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "kpi-label" }, "Promedio general", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["kpi-valor", `clas-${datos.value.global?.clasificacion ?? 'no_aplica'}`])
                          }, _toDisplayString(fmtVal(datos.value.global?.valoracion)), 3)
                        ]))
                      : _createCommentVNode("", true),
                    (kpiVisible('nivel'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "kpi-label" }, "Nivel general", -1)),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(datos.value.global?.grado ?? '—'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.tipo === 'TABLA_GENERAL')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("table", _hoisted_23, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            (col('n_factor'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_24, "N°"))
                              : _createCommentVNode("", true),
                            (col('nombre_factor'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Factor"))
                              : _createCommentVNode("", true),
                            (col('peso_factor'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_26, "Ponderación"))
                              : _createCommentVNode("", true),
                            (col('n_caract'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_27, "N° C."))
                              : _createCommentVNode("", true),
                            (col('nombre_caract'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_28, "Característica"))
                              : _createCommentVNode("", true),
                            (col('n_aspecto'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_29, "N° A."))
                              : _createCommentVNode("", true),
                            (col('aspecto'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_30, "Aspecto"))
                              : _createCommentVNode("", true),
                            (col('valoracion'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_31, "Valoración"))
                              : _createCommentVNode("", true),
                            (col('gradacion'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_32, "Gradación"))
                              : _createCommentVNode("", true),
                            (col('pct'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_33, "% Prom. Pond."))
                              : _createCommentVNode("", true),
                            (col('nivel'))
                              ? (_openBlock(), _createElementBlock("th", _hoisted_34, "Nivel de Cumplimiento"))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                              return (_openBlock(), _createElementBlock("th", {
                                key: ec.id,
                                class: "col-extra"
                              }, _toDisplayString(ec.titulo), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasVista.value, (fila) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: fila.key
                            }, [
                              (fila.tipo === 'aspecto')
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                                    (col('n_factor') && fila.mostrarFactor)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 0,
                                          rowspan: fila.factorRowspan,
                                          class: "celda-factor"
                                        }, _toDisplayString(fmtOrdinal(fila.factor.ordinal)), 9, _hoisted_36))
                                      : _createCommentVNode("", true),
                                    (col('nombre_factor') && fila.mostrarFactor)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 1,
                                          rowspan: fila.factorRowspan,
                                          class: "celda-factor nombre"
                                        }, _toDisplayString(fila.factor.nombre), 9, _hoisted_37))
                                      : _createCommentVNode("", true),
                                    (col('peso_factor') && fila.mostrarFactor)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 2,
                                          rowspan: fila.factorRowspan,
                                          class: "celda-factor col-num"
                                        }, _toDisplayString(fmtPeso(fila.factor.peso)), 9, _hoisted_38))
                                      : _createCommentVNode("", true),
                                    (fila.caract)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          (col('n_caract') && fila.mostrarCaract)
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 0,
                                                rowspan: fila.caractRowspan
                                              }, _toDisplayString(fmtOrdinal(fila.caract.ordinal)), 9, _hoisted_39))
                                            : _createCommentVNode("", true),
                                          (col('nombre_caract') && fila.mostrarCaract)
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 1,
                                                rowspan: fila.caractRowspan,
                                                class: "nombre"
                                              }, _toDisplayString(fila.caract.nombre), 9, _hoisted_40))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          (col('n_caract'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_41))
                                            : _createCommentVNode("", true),
                                          (col('nombre_caract'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_42, "—"))
                                            : _createCommentVNode("", true)
                                        ], 64)),
                                    (col('n_aspecto'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(fmtOrdinal(fila.aspecto?.ordinal)), 1))
                                      : _createCommentVNode("", true),
                                    (col('aspecto'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(fila.aspecto?.nombre ?? '—'), 1))
                                      : _createCommentVNode("", true),
                                    (col('valoracion'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(fmtVal(fila.aspecto?.valoracion ?? null)), 1))
                                      : _createCommentVNode("", true),
                                    (col('gradacion') && fila.caract && fila.mostrarCaract)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 8,
                                          rowspan: fila.caractRowspan,
                                          class: "col-num"
                                        }, _toDisplayString(fmtPeso(fila.caract.peso)), 9, _hoisted_46))
                                      : (col('gradacion') && !fila.caract)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_47, "—"))
                                        : _createCommentVNode("", true),
                                    (col('pct') && fila.caract && fila.mostrarCaract)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 10,
                                          rowspan: fila.caractRowspan,
                                          class: "col-num"
                                        }, _toDisplayString(fmtVal(fila.caract.valoracion)), 9, _hoisted_48))
                                      : (col('pct') && !fila.caract)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_49, "—"))
                                        : _createCommentVNode("", true),
                                    (col('nivel'))
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 12,
                                          class: _normalizeClass(["nivel", `clas-${fila.aspecto?.clasificacion ?? 'no_aplica'}`])
                                        }, _toDisplayString(fila.aspecto?.grado ?? '—'), 3))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: ec.id
                                      }, [
                                        (fila.mostrarFactor)
                                          ? (_openBlock(), _createElementBlock("td", {
                                              key: 0,
                                              rowspan: fila.factorRowspan,
                                              class: "col-extra"
                                            }, _toDisplayString(ec.filas[`f_${fila.factor.id_componente}`] ?? ''), 9, _hoisted_50))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                                    _createElementVNode("td", { colspan: colSpanSubtotal.value }, "SUBTOTAL FACTOR " + _toDisplayString(fmtOrdinal(fila.factor.ordinal)) + " · " + _toDisplayString(fila.factor.nombre), 9, _hoisted_52),
                                    (col('valoracion'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_53, _toDisplayString(fmtVal(fila.factor.valoracion)), 1))
                                      : _createCommentVNode("", true),
                                    (col('gradacion'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(fmtPeso(fila.factor.peso)), 1))
                                      : _createCommentVNode("", true),
                                    (col('pct'))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(fmtPct(fila.factor.pct)), 1))
                                      : _createCommentVNode("", true),
                                    (col('nivel'))
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 3,
                                          class: _normalizeClass(["nivel", `clas-${fila.factor.clasificacion}`])
                                        }, _toDisplayString(fila.factor.grado ?? '—'), 3))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: ec.id
                                      }))
                                    }), 128))
                                  ]))
                            ], 64))
                          }), 128)),
                          (datos.value.global)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                                _createElementVNode("td", { colspan: colSpanSubtotal.value }, "CALIFICACIÓN GLOBAL DEL MODELO", 8, _hoisted_57),
                                (col('valoracion'))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(fmtVal(datos.value.global.valoracion)), 1))
                                  : _createCommentVNode("", true),
                                (col('gradacion'))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_59, "100%"))
                                  : _createCommentVNode("", true),
                                (col('pct'))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(fmtPct(datos.value.global.pct)), 1))
                                  : _createCommentVNode("", true),
                                (col('nivel'))
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 3,
                                      class: _normalizeClass(["nivel", `clas-${datos.value.global.clasificacion}`])
                                    }, _toDisplayString(datos.value.global.grado ?? '—'), 3))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: ec.id
                                  }))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_ctx.tipo === 'TABLA_SEMAFORO')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datos.value.resumen, (r, k) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: k,
                              class: "resumen-card"
                            }, [
                              _createElementVNode("span", _hoisted_63, _toDisplayString(nivelLabel(String(k))), 1),
                              _createElementVNode("div", _hoisted_64, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "pt fuerte" }, null, -1)),
                                _cache[6] || (_cache[6] = _createTextVNode(" Fuertes ")),
                                _createElementVNode("b", null, _toDisplayString(r.fuerte), 1),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                _createElementVNode("small", null, "(" + _toDisplayString(pctResumen(r.fuerte, r.total)) + ")", 1)
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "pt debil" }, null, -1)),
                                _cache[9] || (_cache[9] = _createTextVNode(" Débiles ")),
                                _createElementVNode("b", null, _toDisplayString(r.debil), 1),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("small", null, "(" + _toDisplayString(pctResumen(r.debil, r.total)) + ")", 1)
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "pt muy_debil" }, null, -1)),
                                _cache[12] || (_cache[12] = _createTextVNode(" Muy débiles ")),
                                _createElementVNode("b", null, _toDisplayString(r.muy_debil), 1),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("small", null, "(" + _toDisplayString(pctResumen(r.muy_debil, r.total)) + ")", 1)
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "pt no_aplica" }, null, -1)),
                                _cache[15] || (_cache[15] = _createTextVNode(" No aplica ")),
                                _createElementVNode("b", null, _toDisplayString(r.no_aplica), 1)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("table", _hoisted_69, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                (col('caract'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_70, "Característica"))
                                  : _createCommentVNode("", true),
                                (col('aspecto'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_71, "Aspecto"))
                                  : _createCommentVNode("", true),
                                (col('valoracion'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_72, "Valoración"))
                                  : _createCommentVNode("", true),
                                (col('fuerte'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_73, "Fuerte"))
                                  : _createCommentVNode("", true),
                                (col('debil'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_74, "Débil"))
                                  : _createCommentVNode("", true),
                                (col('muy_debil'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_75, "Muy débil"))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    key: ec.id,
                                    class: "col-extra"
                                  }, _toDisplayString(ec.titulo), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposSemaforo.value, (grupo) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: grupo.id
                                }, [
                                  (col('caract'))
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                                        _createElementVNode("td", { colspan: colSpanSemaforo.value }, _toDisplayString(fmtOrdinal(grupo.ordinal)) + " " + _toDisplayString(grupo.nombre), 9, _hoisted_77)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.hojas, (a) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: grupo.id + '-' + a.id_componente
                                    }, [
                                      (col('caract'))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_78))
                                        : _createCommentVNode("", true),
                                      (col('aspecto'))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_79, _toDisplayString((a.ordinal ? fmtOrdinal(a.ordinal) + '. ' : '') + a.nombre), 1))
                                        : _createCommentVNode("", true),
                                      (col('valoracion'))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_80, _toDisplayString(fmtVal(a.valoracion)), 1))
                                        : _createCommentVNode("", true),
                                      (col('fuerte'))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_81, [
                                            (a.clasificacion === 'fuerte')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (col('debil'))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_83, [
                                            (a.clasificacion === 'debil')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_84))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (col('muy_debil'))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_85, [
                                            (a.clasificacion === 'muy_debil')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_86))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: ec.id,
                                          class: "col-extra"
                                        }, _toDisplayString(ec.filas[`c_${a.id_componente}`] ?? ''), 1))
                                      }), 128))
                                    ]))
                                  }), 128))
                                ], 64))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : (_ctx.tipo === 'TABLA_ESTRUCTURA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                          _createElementVNode("table", _hoisted_88, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                (col('codigo'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_89, "Código"))
                                  : _createCommentVNode("", true),
                                (col('tipo'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_90, "Tipo"))
                                  : _createCommentVNode("", true),
                                (col('nombre'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_91, "Nombre"))
                                  : _createCommentVNode("", true),
                                (col('peso'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_92, "Ponderación"))
                                  : _createCommentVNode("", true),
                                (col('valoracion'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_93, "Valoración"))
                                  : _createCommentVNode("", true),
                                (col('pct'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_94, "%"))
                                  : _createCommentVNode("", true),
                                (col('grado'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_95, "Grado"))
                                  : _createCommentVNode("", true),
                                (col('clasificacion'))
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_96, "Clasificación"))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    key: ec.id,
                                    class: "col-extra"
                                  }, _toDisplayString(ec.titulo), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasEstructura.value, (f) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: f.key,
                                  class: _normalizeClass('nivel-' + f.tipoNivel)
                                }, [
                                  (col('codigo'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_97, _toDisplayString(fmtOrdinal(f.codigo)), 1))
                                    : _createCommentVNode("", true),
                                  (col('tipo'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_98, _toDisplayString(f.tipo), 1))
                                    : _createCommentVNode("", true),
                                  (col('nombre'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_99, _toDisplayString(f.nombre), 1))
                                    : _createCommentVNode("", true),
                                  (col('peso'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_100, _toDisplayString(f.peso === null ? '—' : fmtPeso(f.peso)), 1))
                                    : _createCommentVNode("", true),
                                  (col('valoracion'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_101, _toDisplayString(fmtVal(f.valoracion)), 1))
                                    : _createCommentVNode("", true),
                                  (col('pct'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_102, _toDisplayString(fmtPct(f.pct)), 1))
                                    : _createCommentVNode("", true),
                                  (col('grado'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_103, _toDisplayString(f.grado ?? '—'), 1))
                                    : _createCommentVNode("", true),
                                  (col('clasificacion'))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_104, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["badge-clas", `clas-${f.clasificacion}`])
                                        }, _toDisplayString(clasLabel(f.clasificacion)), 3)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraCols.value, (ec) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: ec.id,
                                      class: "col-extra"
                                    }, _toDisplayString(ec.filas[f.stableKey] ?? ''), 1))
                                  }), 128))
                                ], 2))
                              }), 128))
                            ])
                          ])
                        ]))
                      : (_ctx.tipo === 'GRAFICOS_TODOS')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(graficosVisibles.value, (g) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: g.id,
                                class: "grafico-card",
                                style: _normalizeStyle({ width: anchoGrafico.value + 'px' })
                              }, [
                                _createElementVNode("p", _hoisted_106, "Factor " + _toDisplayString(fmtOrdinal(g.ordinal)) + ": " + _toDisplayString(g.nombre), 1),
                                (_openBlock(), _createElementBlock("svg", {
                                  viewBox: `0 0 ${g.width} ${svgH.value}`,
                                  class: "grafico-svg",
                                  preserveAspectRatio: "xMidYMid meet"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "38",
                                    y1: "10",
                                    x2: "38",
                                    y2: svgH.value - 40,
                                    stroke: "#ccc"
                                  }, null, 8, _hoisted_108),
                                  _createElementVNode("line", {
                                    x1: "38",
                                    y1: svgH.value - 40,
                                    x2: g.width - 10,
                                    y2: svgH.value - 40,
                                    stroke: "#ccc"
                                  }, null, 8, _hoisted_109),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ejeTicks.value, (t) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: 't' + t
                                    }, [
                                      _createElementVNode("line", {
                                        x1: "34",
                                        y1: yPos(t),
                                        x2: "38",
                                        y2: yPos(t),
                                        stroke: "#999"
                                      }, null, 8, _hoisted_110),
                                      _createElementVNode("text", {
                                        x: "30",
                                        y: yPos(t) + 3,
                                        "text-anchor": "end",
                                        class: "eje-label"
                                      }, _toDisplayString(t), 9, _hoisted_111)
                                    ], 64))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.barras, (b, i) => {
                                    return (_openBlock(), _createElementBlock("g", {
                                      key: 'b' + i
                                    }, [
                                      _createElementVNode("rect", {
                                        x: 48 + i * g.paso,
                                        y: yPos(b.valor ?? 0),
                                        width: g.anchoBarra,
                                        height: svgH.value - 40 - yPos(b.valor ?? 0),
                                        fill: clasColor(b.clasificacion),
                                        rx: "2"
                                      }, null, 8, _hoisted_112),
                                      _createElementVNode("text", {
                                        x: 48 + i * g.paso + g.anchoBarra / 2,
                                        y: yPos(b.valor ?? 0) - 4,
                                        "text-anchor": "middle",
                                        class: "barra-val"
                                      }, _toDisplayString(b.valor === null ? '—' : b.valor.toFixed(2)), 9, _hoisted_113),
                                      _createElementVNode("text", {
                                        x: 48 + i * g.paso + g.anchoBarra / 2,
                                        y: svgH.value - 26,
                                        "text-anchor": "middle",
                                        class: "barra-label"
                                      }, _toDisplayString(fmtOrdinal(b.ordinal)), 9, _hoisted_114)
                                    ]))
                                  }), 128))
                                ], 8, _hoisted_107))
                              ], 4))
                            }), 128))
                          ]))
                        : (_ctx.tipo === 'GRAFICO_FACTOR')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                              (graficoFactor.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "grafico-card",
                                    style: _normalizeStyle({ width: anchoGrafico.value + 'px' })
                                  }, [
                                    _createElementVNode("p", _hoisted_116, "Factor " + _toDisplayString(fmtOrdinal(graficoFactor.value.ordinal)) + ": " + _toDisplayString(graficoFactor.value.nombre), 1),
                                    (_openBlock(), _createElementBlock("svg", {
                                      viewBox: `0 0 ${graficoFactor.value.width} ${svgH.value}`,
                                      class: "grafico-svg",
                                      preserveAspectRatio: "xMidYMid meet"
                                    }, [
                                      _createElementVNode("line", {
                                        x1: "38",
                                        y1: "10",
                                        x2: "38",
                                        y2: svgH.value - 40,
                                        stroke: "#ccc"
                                      }, null, 8, _hoisted_118),
                                      _createElementVNode("line", {
                                        x1: "38",
                                        y1: svgH.value - 40,
                                        x2: graficoFactor.value.width - 10,
                                        y2: svgH.value - 40,
                                        stroke: "#ccc"
                                      }, null, 8, _hoisted_119),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ejeTicks.value, (t) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: 't' + t
                                        }, [
                                          _createElementVNode("line", {
                                            x1: "34",
                                            y1: yPos(t),
                                            x2: "38",
                                            y2: yPos(t),
                                            stroke: "#999"
                                          }, null, 8, _hoisted_120),
                                          _createElementVNode("text", {
                                            x: "30",
                                            y: yPos(t) + 3,
                                            "text-anchor": "end",
                                            class: "eje-label"
                                          }, _toDisplayString(t), 9, _hoisted_121)
                                        ], 64))
                                      }), 128)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(graficoFactor.value.barras, (b, i) => {
                                        return (_openBlock(), _createElementBlock("g", {
                                          key: 'b' + i
                                        }, [
                                          _createElementVNode("rect", {
                                            x: 48 + i * graficoFactor.value.paso,
                                            y: yPos(b.valor ?? 0),
                                            width: graficoFactor.value.anchoBarra,
                                            height: svgH.value - 40 - yPos(b.valor ?? 0),
                                            fill: clasColor(b.clasificacion),
                                            rx: "2"
                                          }, null, 8, _hoisted_122),
                                          _createElementVNode("text", {
                                            x: 48 + i * graficoFactor.value.paso + graficoFactor.value.anchoBarra / 2,
                                            y: yPos(b.valor ?? 0) - 4,
                                            "text-anchor": "middle",
                                            class: "barra-val"
                                          }, _toDisplayString(b.valor === null ? '—' : b.valor.toFixed(2)), 9, _hoisted_123),
                                          _createElementVNode("text", {
                                            x: 48 + i * graficoFactor.value.paso + graficoFactor.value.anchoBarra / 2,
                                            y: svgH.value - 26,
                                            "text-anchor": "middle",
                                            class: "barra-label"
                                          }, _toDisplayString(fmtOrdinal(b.ordinal)), 9, _hoisted_124)
                                        ]))
                                      }), 128))
                                    ], 8, _hoisted_117))
                                  ], 4))
                                : (_openBlock(), _createElementBlock("p", _hoisted_125, "Factor no encontrado."))
                            ]))
                          : _createCommentVNode("", true)
  ], 512))
}
}

})